<script>
//utils
import singleEliminationRoundHelper from './mixins/roundHelper';
//components
import MatchCard from '../components/DuelMatchCard.vue';
import MatchCardDetails from '../components/DuelMatchCardDetails.vue';
import Grid from '../components/GridView';
const getRoundVisibleCountBase = (roundIndex, pageSize) =>
  Math.ceil(pageSize / 2 ** roundIndex);
const getRoundItemHeight = basicHeight => roundIndex => {
  // if (roundsCount === 2 && roundIndex === 1) {
  //   return 600;
  // }
  return basicHeight * 2 ** roundIndex;
};
const getNextMatchIndex = index => Math.floor(index / 2);
const matchProps = () => {
  // const offset =
  //   roundsCount === 2 && roundIndex === 1
  //     ? {
  //         currentY: '-50px',
  //       }
  //     : null;

  return {
    props: {
      isTreeMode: true,
      canSwapPlayers: true,
      // offset,
    },
  };
};
export default {
  name: 'TournamentSingeElimination',
  functional: true,
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context) {
    return h(Grid, {
      props: {
        roundName: singleEliminationRoundHelper.methods.roundName,
        getRoundItemHeight,
        getRoundVisibleCountBase,
        getNextMatchIndex,
        matchProps,
        isCollapsible: false,
        matchCardComponent: MatchCard,
        matchCardDetailsComponent: MatchCardDetails,
        isAdmin: context.props.isAdmin,
      },
      on: context.listeners,
    });
  },
};
</script>
